import React from 'react';
import { useLocation } from 'react-router-dom';
import CONFIG from 'utils/config';

const PlatformMaintenanceBanner = () => {
  const { pathname } = useLocation();

  const now = new Date();
  const startTime = new Date(CONFIG.PLATFORM_MAINTENANCE_START_TIME);
  const endTime = new Date(CONFIG.PLATFORM_MAINTENANCE_END_TIME);

  if (now < startTime || now > endTime) {
    return null;
  }

  return (
    <div className="w-full text-center px-4 py-3 z-50 text-sm md:text-base text-black" style={{ backgroundColor: 'rgb(245 164 164)' }}>
      <p>
        <span className="mr-2">⚠️</span>
        <span className="font-bold">Platform Maintenance Notice:</span> All sign-ups will be paused <span className="font-bold">Apr 10–12, 2026.</span> The platform will be offline on <span className="font-bold">Apr 13 2026,</span> 10am–12pm SGT (~2 hours) during which logins and all actions will be temporarily unavailable. Thank you for your patience!
      </p>
    </div>
  );
};

export default PlatformMaintenanceBanner;
